<template>
  <form @submit.prevent="save">
    <v-card>
      <v-toolbar
        flat
        color="primary"
      >
        <v-toolbar-title>Passwort</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <span>
          Dein Passwort muss aus mindestens 8 Zeichen lang sein. Es muss zumindest einen Kleinbuchstaben, einen Großbuchstaben und eine Zahl enthalten.
        </span>
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.current_password"
          label="aktuelles Passwort"
          required
          autocomplete="current-password"
          :error="form.errors.updatePassword && form.errors.updatePassword.current_password ? true : false"
          :error-messages="form.errors.updatePassword ? form.errors.updatePassword.current_password : ''"
          :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showCurrentPassword ? 'text' : 'password'"
          @click:append="showCurrentPassword = !showCurrentPassword"
        />
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.password"
          label="neues Passwort"
          required
          autocomplete="new-password"
          :error="form.errors.updatePassword && form.errors.updatePassword.password ? true : false"
          :error-messages="form.errors.updatePassword ? form.errors.updatePassword.password : ''"
          hint="At least 8 characters"
          :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showNewPassword ? 'text' : 'password'"
          @click:append="showNewPassword = !showNewPassword"
        />
      </v-card-text>
      <v-card-text>
        <v-text-field
          v-model="form.password_confirmation"
          label="neues Passwort bestätigen"
          required
          autocomplete="new-password"
          :error="form.errors.updatePassword && form.errors.updatePassword.password_confirmation ? true : false"
          :error-messages="form.errors.updatePassword ? form.errors.updatePassword.password_confirmation : ''"
          :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPasswordConfirmation ? 'text' : 'password'"
          @click:append="showPasswordConfirmation = !showPasswordConfirmation"
        />
      </v-card-text>
      <v-card-actions>
        <v-alert type="success" dismissible :v-model="alert" :value="alert" dense>
          Passwort geändert
        </v-alert>
        <v-spacer />
        <v-btn
          color="primary"
          type="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>

export default {
   data () {
      return {
         showCurrentPassword: false,
         showPasswordConfirmation: false,
         showNewPassword: false,
         form: this.$inertia.form({
            current_password: '',
            password: '',
            password_confirmation: '',
         }),
         alert: false
      }
   },

   computed: {
      errors () {
         return Object.keys(this.$page.props.errors).length > 0
      }
   },
   //    mounted () {
   //       if (this.form.wasSuccessful) {
   //          this.form.reset()
   //          this.alert = true
   //       }
   //    },

   methods: {
      save () {
         this.form.put(this.route('user-password.update'), {
            onSuccess: () => {
               this.form.reset()
               this.alert = true
            }
         })
      },
   }
}
</script>
